import React from 'react';
import { map } from 'lodash';

// Local Dependencies
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { widgetsTabFlow as WidgetsTabFlow } from 'modules/widgetsTabFlow';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberHealthInfo as MemberHealthInfo } from 'ui/views/widgets/memberHealthInfo';
 *
 * // render
 * <MemberHealthInfo propName='propValue'/>
 */
export const memberHealthInfoSuccess = ( props ) => {
    return (
        <div className='ui-member-health-info'>
             <WidgetsTabFlow
                tabs={ props.tabs }
                theme='plain'
                requestPayload={ props.requestPayload }
            />
        </div>
    );
};

// set display name
memberHealthInfoSuccess.displayName = 'memberHealthInfoSuccess';

// set default props
memberHealthInfoSuccess.defaultProps = {};

// prop types
memberHealthInfoSuccess.propTypes = {};

/***************************************** */

// Preloader view
export const memberHealthInfoPreloader = () => {
    return (
        <div className='ui-member-health-info-preloader'>
            <div className='ui-member-health-info-preloader__tabList'>
                <div className='ui-member-health-info-preloader__tabList__tab'></div>
                <div className='ui-member-health-info-preloader__tabList__tab'></div>
                <div className='ui-member-health-info-preloader__tabList__tab'></div>
            </div>
            <div className='ui-member-health-info-preloader__tab-container'>
                {
                    map( [ 1, 2, 3, 4, 5 ], item => {
                        return (
                            <div key={ item } className='ui-member-health-info-preloader__tab-container__item'/>
                        );
                    } )
                }
            </div>
        </div>
    );
};

// set display name
memberHealthInfoPreloader.displayName = 'memberHealthInfoPreloader';

// set default props
memberHealthInfoPreloader.defaultProps = {};

// prop types
memberHealthInfoPreloader.propTypes = {};

/************************** */
export const memberHealthInfo = withNetworkState( memberHealthInfoPreloader, memberHealthInfoSuccess );
